import { Crud, HttpClient, httpClient } from 'lib/HttpClient';
import { CampaignItemRequestData } from './models/CampaignItem';

class CampaignApi extends Crud {
    constructor(client: HttpClient) {
        super(client, process.env.CAMPAIGN_SERVICE_URL, 'campaigns', {
            'x-auth-id': process.env.CONSOLE_FIREBASE_PROJECT_ID
        });
    }
    getTriggersList(campaignId: string) {
        return this.httpClient.get(`${this.api}/campaigns/${campaignId}/triggers`, {
            headers: {
                'x-auth-id': process.env.CONSOLE_FIREBASE_PROJECT_ID
            }
        });
    }
    createTrigger(campaignId: string, data: CampaignItemRequestData) {
        return this.httpClient.post(`${this.api}/campaigns/${campaignId}/triggers`, {
            body: { data },
            headers: {
                'x-auth-id': process.env.CONSOLE_FIREBASE_PROJECT_ID
            }
        });
    }
    updateTrigger(campaignId: string, triggerId: string, data: CampaignItemRequestData) {
        return this.httpClient.put(`${this.api}/campaigns/${campaignId}/triggers/${triggerId}`, {
            body: { data },
            headers: {
                'x-auth-id': process.env.CONSOLE_FIREBASE_PROJECT_ID
            }
        });
    }
    deleteTrigger(campaignId: string, triggerId: string) {
        return this.httpClient.delete(`${this.api}/campaigns/${campaignId}/triggers/${triggerId}`, {
            headers: {
                'x-auth-id': process.env.CONSOLE_FIREBASE_PROJECT_ID
            },
            skipResponseBody: true
        });
    }

    public async stop(campaignId: string) {
        const headers = {
            'x-auth-id': process.env.CONSOLE_FIREBASE_PROJECT_ID
        };
        return this.httpClient.post(`${this.api}/campaigns/${campaignId}/stop`, { headers });
    }

    public async start(campaignId: string) {
        const headers = {
            'x-auth-id': process.env.CONSOLE_FIREBASE_PROJECT_ID
        };
        return this.httpClient.post(`${this.api}/campaigns/${campaignId}/start`, { headers });
    }
}

export const campaignApi = new CampaignApi(httpClient);
